<template>
    <div>
        <h1 class="display-heading">Bulk Invite Company Users</h1>
        <template v-if="!isPreview">
            <div class="mb-3">
                <h5>Instructions</h5>
                <ol>
                    <li>
                        Download the sample file template here.
                        <div><a href="/static/samples/sample_bulk_invite_template.xlsx" target="_blank" class="mt-1 mb-2 btn btn-primary btn-primary-insv">Download Template File</a></div>
                    </li>
                    <li>
                        Open the downloaded file and fill up the file with the required fields. Example as below.
                        <div class="mt-1 mb-2">
                            <img src="/static/samples/sample_bulk_invite_format.png" class="img img-fluid">
                        </div>
                    </li>

                    <li>Select and upload the file here.</li>
                    <li>Review the user list and proceed!</li>
                </ol>
            </div>

            <div class="card">
                    <div class="card-header">Upload User List</div>
                    <div class="card-body">
                        <form @submit.prevent="validateForm">
                            <div>
                                <div class="form-group row">
                                    <label class="col-sm-3 col-xl-2 col-form-label">User List File</label>
                                    <div class="col-sm-9 col-xl-10">
                                        <input id="uploadFileInput" type="file" v-validate="'required|mimes:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" data-vv-as="user list file" name="userList"
                                            :class="{'is-invalid':  validationErrors.has('userList')}">
                                        <div v-show="validationErrors.has('userList')" class="invalid-feedback">
                                            {{ validationErrors.first('userList') }}
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                        <p v-show="isSubmitMessageShown" :class="{
                                            'text-danger': isSubmitMessageError,
                                            'mb-3': true
                                        }">
                                            {{submitMessage}}
                                        </p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2">
                                        <button class="btn btn-primary btn-primary-insv">Upload User List File</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
        </template>
        <template v-else>
            <h5>Preview Content</h5>
            <div class="mb-3">
                <p>Kindly review your uploaded invitee list: (triple check that all entries are correct!)</p>
                <div ref="tableSection" style="max-height: 400px; overflow-y: auto;">
                    <div class="table-responsive">
                        <table ref="listTable" class="table table-hover">
                            <colgroup>
                                <col width="40">
                                <col>
                                <col>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" class="text-nowrap">Email Address</th>
                                    <th scope="col" class="text-nowrap">Full Name</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(invite, index) in inviteList" :key="index">
                                    <th scope="col">{{index+1}}</th>
                                    <td>
                                        {{invite.e}}
                                    </td>
                                    <td>
                                        {{invite.n}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <p>*{{inviteList.length}} row{{inviteList.length>1 ? 's' : ''}} of data detected.</p>
            </div>
            <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="confirmInvitation">Confirm and Send Invitations</button>
            <button type="button" class="btn btn-secondary" @click="startOver">Reset</button>
        </template>

        <popup-modal ref="popupAddDone" title="Invite Users" :hasCloseButton="false" sizeClass="modal-lg">
            <template slot="content">
                <p>{{inviteResultText}}</p>

                <template v-if="inviteWithErrors">
                    <p>{{inviteResultErrorText}}</p>

                    <table class="table">
                        <colgroup>
                            <col width="50">
                            <col>
                            <col>
                            <col>
                        </colgroup>
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email Address</th>
                                <th scope="col">Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(invite, index) in inviteErrorList" :key="index">
                                <th scope="row">{{index+1}}</th>
                                <td>{{invite.name ? invite.name : '-'}}</td>
                                <td>{{invite.email}}</td>
                                <td>{{invite.reason ? invite.reason : '-'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </template>
            <template slot="footer">
                <template v-if="!bulkInviteHasError">
                    <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="viewInvitationReport">
                        View Invitation Report
                    </button>
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissDoneConfirmation">Upload Another List</button>
                </template>
                <template v-else>
                    <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="tryAgain">Try Again</button>

                    <button type="button" class="btn btn-secondary" @click="cancelTry">Cancel</button>
                </template>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import {
    Validator
} from 'vee-validate';
export default {
    'name': 'BulkUploadDrugs',
    'components': {
        popupModal
    },
    data () {
        return {
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',
            'isPreview': false,
            'rowMessage': '',
            'inviteList': [],

            'inviteWithErrors': false,
            'inviteResultText': '',
            'inviteResultErrorText': '',
            'inviteErrorList': []
        };
    },
    mounted () {
        const dict = {
            'custom': {
                'drugList': {
                    'required': 'You must select a file to upload.',
                    'mimes': 'The selected file must be an excel file.'
                }
            }
        };
        Validator.localize('en', dict);
        this.$validator.localize('en', dict);
    },
    'methods': {
        validateForm () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            this.$validator.validateAll().then((isValidate) => {
                if (isValidate) {
                    let bulkFile = document.querySelector('#uploadFileInput');
                    let formData = new FormData();
                    formData.append('BulkInviteFile', bulkFile.files[0]);
                    this.submitMessage = 'Uploading and processing bulk invite file.';

                    this.axios.post('Invite/BulkUpload', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        } }).then(({ data }) => {
                        if (data.data.s) {
                            this.isSubmitMessageError = false;

                            this.inviteList = data.data.il.map((invite) => ({
                                'n': invite.n,
                                'e': invite.e
                            }));

                            this.isPreview = true;
                        } else {
                            this.isSubmitMessageError = true;
                            this.submitMessage = data.data.e;
                        }
                    }).catch((error) => {
                        this.isSubmitMessageError = true;
                        if (error.response.data) {
                            this.submitMessage = error.response.data.message;
                        } else {
                            this.submitMessage = 'Error processing bulk upload. Please try again.';
                        }
                    });
                } else {
                    this.isSubmitMessageError = true;
                    this.submitMessage = 'You have error in the form. Please check your input(s) before saving your invitation request.';
                }
            });
        },
        confirmInvitation () {
            this.axios.post('/Invite/Company', this.inviteList).then(({
                data
            }) => {
                let successList = data.data.si;
                let failedList = data.data.fi;

                this.inviteResultText =
                                `${successList.length} invitation${successList.length > 1 ? 's' : ''} created.`;

                if (failedList.length > 0) {
                    this.inviteWithErrors = true;
                    this.inviteResultErrorText = `${failedList.length} failed invitation${failedList.length > 1 ? 's' : ''}.`;
                    this.inviteErrorList = failedList.map((invitation) => ({
                        'email': invitation.e,
                        'name': invitation.n,
                        'reason': invitation.fr
                    }));
                } else {
                    this.inviteWithErrors = false;
                    this.inviteResultErrorText = '';
                    this.inviteErrorList = [];
                }

                this.$refs.popupAddDone.show();
            }).catch(() => {
                this.inviteResultText = 'Error saving invitations. Please try again.';
                this.$refs.popupAddDone.show();
            });
        },
        startOver () {
            window.location.reload();
        },
        dismissDoneConfirmation () {
            this.$refs.popupAddDone.hide().then(() => {
                window.location.reload();
            });
        },
        viewInvitationReport () {
            this.$refs.popupAddDone.hide().then(() => {
                this.$router.push({
                    'name': 'company-user-invitation-report'
                });
            });
        },
        tryAgain () {
            this.$refs.popupAddDone.hide().then(() => {
                this.confirmInvitation();
            });
        },
        cancelTry () {
            this.$refs.popupAddDone.hide();
        }
    }
};

</script>

<style>

</style>
